import React from "react";

const DownloadButton = () => {
  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = "/usman_mughal-cv.pdf";
    downloadLink.download = "usman_mughal-cv.pdf";
    downloadLink.click();
  };

  return (
    <button className="btn-primary mt-8 hover:btn-secondary" onClick={handleDownload}>
      Get My CV
    </button>
  );
};

export default DownloadButton;
